import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { DomEventsService } from '@app/common/services/dom-events.service';
import { DomService } from '@app/common/services/dom.service';
import { FooterComponent } from '@app/common/components/footer/footer.component';
import { HeaderComponent } from '@app/common/components/header/header.component';
import { MobileBarComponent } from '@app/common/components/mobile-bar/mobile-bar.component';
import { version } from '../../package.json';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent, FooterComponent, MobileBarComponent],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  private domEventsService = inject(DomEventsService);
  private domService = inject(DomService);

  ngOnInit(): void {
    this.domService.updateMetaNameTag('app-version', version);
    this.domEventsService.init();
  }
}
